var map = {
	"./PRESS-SLIDE1.png": 55033,
	"./PRESS-SLIDE2.png": 88450,
	"./PRESS-SLIDE3.png": 78955,
	"./Pink Kaiju.png": 29041,
	"./carousel-01.png": 17989,
	"./carousel-02.png": 15566,
	"./carousel-03.png": 89207,
	"./carousel-bg.jpg": 88673,
	"./carousel-bg.png": 61673
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34331;